import { CATALOG_LIST } from '../index.js';
import FunctionCard2 from '@/components/FunctionCard2/index.vue';
export default {
  name: 'products',
  components: {
    FunctionCard2
  },
  data() {
    return {
      activeKey: 0,
      catalogList: CATALOG_LIST
    };
  }
};